<template>
  <v-card>
    <v-card-text>
      <h3>Volume</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Cubic Meter',
          val: 1
        },
        {
          text: 'Cubic Kilometer',
          val: 1e-9
        },
        {
          text: 'Cubic Centimeter',
          val: 1000000
        },
        {
          text: 'Cubic Millimeter',
          val: 1000000000
        },
        {
          text: 'Liter',
          val: 1000
        },
        {
          text: 'Milliliter',
          val: 1000000
        },
        {
          text: 'US Gallon',
          val: 264.17217686
        },
        {
          text: 'US Quart',
          val: 1056.6887074
        },
        {
          text: 'US Pint',
          val: 2113.3774149
        },
        {
          text: 'US Cup',
          val: 4226.7548297
        },
        {
          text: 'US Fluid Ounce',
          val: 33814.038638
        },
        {
          text: 'US Table Spoon',
          val: 67628.077276
        },
        {
          text: 'US Tea Spoon',
          val: 202884.23183
        },
        {
          text: 'Imperial Gallon',
          val: 219.9692483
        },
        {
          text: 'Imperial Quart',
          val: 879.8769932
        },
        {
          text: 'Imperial Pint',
          val: 1759.7539864
        },
        {
          text: 'Imperial Fluid Ounce',
          val: 35195.079728
        },
        {
          text: 'Imperial Table Spoon',
          val: 56312.127565
        },
        {
          text: 'Imperial Tea Spoon',
          val: 168936.38269
        },
        {
          text: 'Cubic Mile',
          val: 2.399128636e-10
        },
        {
          text: 'Cubic Yard',
          val: 1.3079506193
        },
        {
          text: 'Cubic Foot',
          val: 35.314666721
        },
        {
          text: 'Cubic Inch',
          val: 61023.744095
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// volume.vue?400323fe